// Builds and submits the OnePay POST form from an assessment-fee initiate
// response — the same redirect used across NIQS fee flows. Shared by the logbook
// detail page and the logbook list so the "pay as usual" behaviour is identical.
export function submitOnePayForm(res: any) {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = res.payment_url || "https://vuvaa.com/ONEPAY/mod/live/main";

  const fields: Record<string, any> = {
    merchant_reg_id: res.merchant_reg_id,
    amt_paid: res.amt_paid,
    merch_trans_id: res.merch_trans_id,
    client_phone: res.client_phone,
    product_desc: res.product_desc,
    client_email: res.client_email,
    client_name: res.client_name,
  };

  Object.entries(fields).forEach(([key, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = key;
    input.value = String(value ?? "");
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
}
